import { IPaginatedRequest } from '@cbgms/api'
import * as types from './types'
import * as requests from '@cbgms/api/modules/departments/requests'

import {
  DELETEDepartmentResponse,
  GETAllDepartments,
  GETDepartmentResponse,
  POSTDepartmentBody,
  POSTDepartmentResponse,
  PUTDepartmentBody,
  PUTDepartmentResponse
} from '@cbgms/api/modules/departments'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const loadAllDepartments = (params?: IPaginatedRequest) =>
  AsyncAction<GETAllDepartments>({
    type: [types.LOAD_ALL_DEPARTMENTS, types.LOAD_ALL_DEPARTMENTS_SUCCESS, types.LOAD_ALL_DEPARTMENTS_FAILED],
    payload: {
      api: 'gms',
      request: requests.loadDepartments(params)
    }
  })

export const getDepartment = (DepartmentUUID: string) =>
  AsyncAction<GETDepartmentResponse>({
    type: [types.LOAD_DEPARTMENT, types.LOAD_DEPARTMENT_SUCCESS, types.LOAD_ALL_DEPARTMENTS_FAILED],
    payload: {
      api: 'gms',
      request: requests.getDepartment(DepartmentUUID)
    }
  })

export const createDepartment = (body: POSTDepartmentBody) =>
  AsyncAction<POSTDepartmentResponse>({
    type: [types.CREATE_DEPARTMENT, types.CREATE_DEPARTMENT_SUCCESS, types.CREATE_DEPARTMENT_FAILED],
    payload: {
      api: 'gms',
      request: requests.createDepartment(body)
    }
  })

export const updateDepartment = (DepartmentUUID: string, body: PUTDepartmentBody) =>
  AsyncAction<PUTDepartmentResponse>({
    type: [types.UPDATE_DEPARTMENT, types.UPDATE_DEPARTMENT_SUCCESS, types.UPDATE_DEPARTMENT_FAILED],
    payload: {
      api: 'gms',
      request: requests.updateDepartment(DepartmentUUID, body)
    }
  })

export const deleteDepartment = (DepartmentUUID: string, dryRun: boolean) =>
  AsyncAction<DELETEDepartmentResponse>({
    type: [types.DELETE_DEPARTMENT, types.DELETE_DEPARTMENT_SUCCESS, types.DELETE_DEPARTMENT_FAILED],
    payload: {
      api: 'gms',
      request: requests.deleteDepartment(DepartmentUUID, dryRun)
    }
  })
